import { ChipsContainer } from "@finanedi.es/storybook"
import { FormikDocumentsProps } from "features/Crear/pages/FormCreacionDocumento/CreacionDocumento"
import { useTranslation } from "react-i18next"

export const CardEtiquetasSetting = ({
  values,
  setFieldValue,
}: FormikDocumentsProps) => {
  const { t } = useTranslation()

  return (
    <div className='tw-w-full tw-flex tw-flex-col tw-mb-3'>
      <p className='tw-text-left tw-mb-0'>
        {t("crear.facturaRec.invoiceClassification")}
      </p>
      <ChipsContainer
        addOnBlur
        max={5}
        placeholder={`${t("validaciones.documentos.detail.addTags")}`}
        maxLength={5}
        separator=','
        containerClassName='tw-w-full tw-h-10'
        className='tw-w-full'
        allowDuplicate={false}
        value={values.tags}
        onChange={(e) => setFieldValue("tags", e.target.value)}
      />
    </div>
  )
}
